export default function BusinessCommonQuestion() {
  return (
    <section
      id="business-common-question"
      className="w-full bg-black font-fira text-white py-12 md:py-20"
    >
      <div className="mx-auto w-[90%] md:w-[80%]">
        <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between md:gap-10">
          <div className="md:max-w-2xl">
            <p className="font-fira text-sm font-normal uppercase tracking-[0.18em] text-[#FFFFFF]">
              Common question
            </p>
            <h2 className="mt-3 font-fira-condensed text-[30px] font-medium leading-tight tracking-tight text-white md:mt-4 md:text-[42px] md:font-semibold">
              Why not just use an
              <br />
              AI course platform?
            </h2>
          </div>

          <div className="flex flex-col gap-5 font-fira text-sm font-normal leading-relaxed text-[#FFFFFF85] md:max-w-md md:text-base">
            <p>
              Course platforms give individuals content. This gives teams
              capability. The difference is the live sessions, the daily
              reinforcement, and the fact that everything is built around your
              workflows - not a generic curriculum.
            </p>
            <p>
              Most teams that come to us have already tried a platform. They
              found that completion rates were low and behaviour change was
              close to zero. That&apos;s the format problem again.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
